// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".break-word[data-v-419156ba] {\n  word-break: break-word;\n}", ""]);
// Exports
module.exports = exports;
